module.exports = __webpack_public_path__ + "img/register.3ae09ab3.svg";